import {ContentContext} from "../../../../utils/contexts";

const { Popover, MenuList, MenuItem, ListItemIcon, ListItemText, Button, withStyles } = window.Material;
const { InsertDriveFile, Folder, Check, Autorenew, Clear, ArrowDropDown } = window.MaterialIcons;
import { PathPickerType } from "../../../../types/enums";
import { Item } from '../../../../types/types';

const styles = theme => ({
  button: {
    padding: '0.5rem',
    minWidth: '0',
  },
  label: {
    fontSize: '11px',
  },
});

class Picker extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      anchor: null,
    };
  }

  handleDropDownClick = event => {
    this.setState({ anchor: event.currentTarget });
  };

  closeMenu = () => {
    this.setState(() => ({ anchor: null }));
  };

  handleSelect = name => {
    const { content, selected, type, setProperty, hidden } = this.context;

    let newSelected = {
      ...selected,
    };

    switch (name) {
      case 'folders': {
        content.forEach((item: Item) => {
          if (!hidden[item.nodeRef] && item.type === PathPickerType.FOLDER && !selected[item.nodeRef]) {
            newSelected[item.nodeRef] = item.nodeRef;
          }
        });

        break;
      }
      case 'files': {
        content.forEach((item: Item) => {
          if (!hidden[item.nodeRef] && item.type === PathPickerType.FILE && !selected[item.nodeRef]) {
            newSelected[item.nodeRef] = item.nodeRef;
          }
        });

        break;
      }
      case 'all': {
        content.forEach((item: Item) => {
          if (!hidden[item.nodeRef] && item.type === type && !selected[item.nodeRef]) {
            newSelected[item.nodeRef] = item.nodeRef;
          }
        });

        break;
      }
      case 'invert': {
        content.forEach((item: Item) => {
          if (!hidden[item.nodeRef] && item.type === type) {
            if (selected[item.nodeRef]) {
              delete newSelected[item.nodeRef];
            } else {
              newSelected[item.nodeRef] = item.nodeRef;
            }
          }
        });

        break;
      }
      case 'cancel': {
        content.forEach((item: Item) => {
          if (!hidden[item.nodeRef] && item.type === type) {
            if (selected[item.nodeRef]) {
              delete newSelected[item.nodeRef];
            }
          }
        });

        break;
      }
      default:
        break;
    }

    setProperty("selected", newSelected);

    this.closeMenu();
  };

  render() {
    const { classes } = this.props;
    const { type, content, loadingContent } = this.context;

    //Hide select all button if no files to pick.
    const showSelectAll = type !== PathPickerType.FILE || content.some(item => item.type === PathPickerType.FILE);

    return (
      <div>
        <Button
          variant="outlined"
          onClick={this.handleDropDownClick}
          classes={{
            root: classes.button,
            label: classes.label,
          }}
          endIcon={<ArrowDropDown />}
          id="pickerDropdownBtn"
          disabled={loadingContent}
        >
          {window.Alfresco.messages.global['button.select']}
        </Button>
        <Popover
          open={this.state.anchor !== null}
          anchorEl={this.state.anchor}
          onClose={this.closeMenu}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
        >
          <MenuList>
            {type === PathPickerType.ALL && (
              <React.Fragment>
                <MenuItem onClick={() => this.handleSelect('files')} id="selectFilesBtn">
                  <ListItemIcon>
                    <InsertDriveFile />
                  </ListItemIcon>
                  <ListItemText
                    primary={window.Alfresco.messages.global['hybridworkflow.destination-select.folderPrefix']}
                  />
                </MenuItem>
                <MenuItem onClick={() => this.handleSelect('folders')} id="selectFoldersBtn">
                  <ListItemIcon>
                    <Folder />
                  </ListItemIcon>
                  <ListItemText primary={window.Alfresco.messages.global['menu.select.folders']} />
                </MenuItem>
              </React.Fragment>
            )}
            {showSelectAll && (
              <MenuItem onClick={() => this.handleSelect('all')} id="selectAllBtn">
                <ListItemIcon>
                  <Check />
                </ListItemIcon>
                <ListItemText primary={window.Alfresco.messages.global['label.selectAll']} />
              </MenuItem>
            )}
            <MenuItem onClick={() => this.handleSelect('invert')} id="invertSelectionBtn">
              <ListItemIcon>
                <Autorenew />
              </ListItemIcon>
              <ListItemText primary={window.Alfresco.messages.global['label.selectInvert']} />
            </MenuItem>
            <MenuItem onClick={() => this.handleSelect('cancel')} id="cancelSelectionBtn">
              <ListItemIcon>
                <Clear />
              </ListItemIcon>
              <ListItemText primary={window.Alfresco.messages.global['edocat.my-tasks.filter.initiator-drop']} />
            </MenuItem>
          </MenuList>
        </Popover>
      </div>
    );
  }
}

Picker.contextType = ContentContext;

export default withStyles(styles)(Picker);
